export default __webpack_public_path__ + "static/9-1dc501ac478e63b436e6c8b30bcb8753.webp";